import { render } from "./EmergencyList.vue?vue&type=template&id=74f59bf4&scoped=true"
import script from "./EmergencyList.vue?vue&type=script&lang=js"
export * from "./EmergencyList.vue?vue&type=script&lang=js"

import "./EmergencyList.vue?vue&type=style&index=0&id=74f59bf4&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f59bf4"]])

export default __exports__